import { get } from 'api/methods';

export interface DocumentoResponse {
  documentoBase64: string;
  nomeDocumento: string;
}

const documentos = {
  download: (idEvento: number, idDocumento: number) => {
    return get<ArrayBuffer>(
      'eventoAssociado',
      `documento/${idDocumento}/evento/${idEvento}/download`,
      {
        responseType: 'arraybuffer',
      }
    );
  },
  downloadBase64: (idDocumento: number) => {
    return get<DocumentoResponse>(
      'eventoAssociado',
      `documento/${idDocumento}/download-base64`
    );
  },
};

export default documentos;
